export const games = () => {
    const games = document.querySelectorAll('.games');
    if (games.length) {
        games.forEach(item => {
            const jsGame = item.querySelector('.js-game');
            if (jsGame) jsGame.click();
        });
    }
}